<template>
  <div class="no-padding">
    <treeselect id="unit" v-if="isLoaded"
                :placeholder="placeholder ? placeholder : (allowTraversal ? '--- Tất cả ---' : '--- Chọn đơn vị ---')"
                v-model="unitId"
                :title="selectedLabel"
                :multiple="multiple"
                :load-options="loadUnits"
                :auto-load-root-options="false"
                :async="true"
                :default-options="options"
                :always-open="alwaysOpen"
                :max-height="maxHeight"
                :cacheOptions="false"
                :normalizer="normalizer"
                :beforeClearAll="resetTree"
                :valueConsistsOf="valueConsistsOf"
                :limit="3"
                :limitText="count => `và ${count} đơn vị nữa`"
                @select="onSelected"
                @deselect="onDeselected"
                ref="treeUnit">
      <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
        <span :class="node.raw.isActive == false ? 'inactive-node' : ''" :title="`${node.raw.code}(${node.raw.nationalBudgetCode}) - ${node.label}`">
          {{ node.label }}
        </span>
      </label>
    </treeselect>
    <template v-if="allowTraversal && unitId">
      <b-form-radio-group>
        <div v-for="opt in traversalOptions" class="custom-control custom-control-inline custom-checkbox">
          <input type="radio" name="unitTraversalOption" class="custom-control-input" :value="opt.id" v-model="selectedTraversalOption" :id="opt.id" @click="uncheck(opt.id)">
          <label :for="opt.id" class="custom-control-label">{{ opt.text }}</label>
        </div>
      </b-form-radio-group>
    </template>
  </div>
</template>
<script>
  import { LOAD_CHILDREN_OPTIONS, ASYNC_SEARCH } from '@riophae/vue-treeselect'
  var timer;
  var searchByName = _.debounce(function (searchQuery, callback, vm) {
    if (searchQuery && searchQuery.length >= 3) {
      vm.getUnitsByName(searchQuery, callback);
    }
  }, 1000);

  export default {
    name: 'UnitTree',
    props: {
      value: {
        type: [String, Number, Array]
      },
      syncSourceType: {
        required: false,
        default: 1
      },
      multiple: {
        default: false
      },
      alwaysOpen: {
        default: false
      },
      maxHeight: {
        type: Number,
        default: 300
      },
      allowTraversal: {
        type: Boolean,
        default: false
      },
      traversalOption: {
        type: Number
      },
      excludeBranches: {
        type: String
      },
      includeInactive: {
        type: Boolean,
        default: false
      },
      valueConsistsOf: {
        type: String,
        default: 'BRANCH_PRIORITY'
      },
      placeholder: {
        type: String
      },
      cached: {
        type: [String, Boolean],
        default: false
      }
    },
    data() {
      return {
        isLoaded: false,
        unitId: this.multiple ? [] : null,
        previouslySelected: null,
        selectedTraversalOption: this.traversalOption,
        traversalOptions: [
          { id: 1, text: 'Đơn vị được quản lý trực tiếp' },
          { id: 2, text: 'Toàn bộ đơn vị cấp dưới' }
        ],
        options: [],
        selectedLabel: null
      }
    },
    computed: {
      excludeBranchesQueryString() {
        return this.excludeBranches ? "&excludeIds=" + this.excludeBranches : '';
      },
      includeInactiveQueryString() {
        if (this.includeInactive) {
          return 'includeInactive=true';
        } else {
          return '';
        }
      },
      syncDataSourceId() {
        var sst = this.$store.state.common.listSyncSourceTypes.find(x => x.id == this.syncSourceType);

        if (sst) {
          return sst.syncDataSourceId ?? this.syncSourceType;
        } else {
          return this.syncSourceType;
        }
      }
    },
    created: function () {
      var vm = this;
      if (this.multiple === false && this.value) {
        vm.$services.get(`lookup/units/${this.value}/uproot?${this.includeInactiveQueryString}`, null, { showLoading: false }).done((response) => {
          vm.options = response;
          vm.isLoaded = true;
          vm.selectUnit(vm.value);
        });
      } else {
        //var cacheUnitId = window.localStorage.getItem(`tsc:${vm.$store.state.identity.username}-${vm.syncDataSourceId}-unitTreeId`);
        //var cacheUnitTraversalOption = window.localStorage.getItem(`tsc:${vm.$store.state.identity.username}-unitTreeTraversalOption`);

        //if (this.cached && cacheUnitTraversalOption) {
        //    this.selectedTraversalOption = parseInt(cacheUnitTraversalOption);
        //}

        //if (this.cached && !this.multiple && cacheUnitId) {
        //    vm.$services.get(`lookup/units/${cacheUnitId}/uproot?${this.includeInactiveQueryString}`, null, { showLoading: false }).done((response) => {
        //        vm.options = response;

        //        //vm.$nextTick(() => vm.unitId = cacheUnitId);
        //        vm.selectUnit(cacheUnitId);
        //        vm.$nextTick(() => {
        //            vm.isLoaded = true;
        //        });
        //    });
        //} else {
        this.options = this.$store.getters.defaultUnitTreeOptions(this.syncDataSourceId).filter(x => vm.excludeBranches == null || x.id != vm.excludeBranches).map(x => {
          return {
            id: x.id,
            name: x.name,
            children: [],
            code: x.code,
            nationalBudgetCode: x.nationalBudgetCode,
            hasChildren: x.hasChildren,
            isActive: x.isActive,
            isDefaultExpanded: x.isDefaultExpanded,
            label: x.label,
            parentId: x.parentId
          };
        });
        this.isLoaded = true;
        //}
      }
    },
    methods: {
      normalizer(node) {
        if (node.children) {
          if (node.children.length == 0) {
            if (node.hasChildren) {
              node.children = null;
            } else {
              delete node.children;
            }
          } else {
            //node.isDefaultExpanded = true;
          }
        } else if (!node.hasChildren) {
          delete node.children;
        }

        return node;
      },
      loadUnits({ action, parentNode, searchQuery, callback, instanceId }) {

        //console.log('action: ' + action);

        if (action === LOAD_CHILDREN_OPTIONS) {
          this.getUnitChildren(parentNode, callback);
        } else if (action === ASYNC_SEARCH) {
          if (searchQuery == null || searchQuery.length < 3) {
            //console.log(action + ' search query:' + searchQuery);
            callback(null, []);
          } else {
            searchByName(searchQuery, callback, this);
          }
        }
      },
      getUnitChildren(parentNode, callback) {
        var tree = this.$refs.treeUnit;
        this.$services.get(`lookup/units/${parentNode.id}/children?${this.excludeBranchesQueryString}&${this.includeInactiveQueryString}`, null, { showLoading: false }).done((response) => {
          parentNode.children = response;
          if (response && response.length > 0) {
            parentNode.isDefaultExpanded = true;
            tree.initialize();
          }
          callback();

        }).fail(() => callback());
      },
      getUnitsByName(searchQuery, callback) {
        var vm = this;
        if (searchQuery && searchQuery.length >= 3 && this.syncDataSourceId) {
          this.$services.get(`lookup/units/tree?syncSourceType=${this.syncDataSourceId}&name=${searchQuery}${this.excludeBranchesQueryString}&${this.includeInactiveQueryString}`, null, { showLoading: false }).done((response) => {
            vm.unitId = null;
            vm.$refs.treeUnit.forest.nodeMap = Object.create(null);
            vm.options = response;
            callback(null, response);
          }).fail(() => callback(null, []));
        } else {
          callback(null, []);
        }
      },
      removeUnit(id) {
        var tree = this.$refs.treeUnit;
        var node = tree.getNode(id.toString());
        node.isDisabled = true;
      },
      selectUnit(id) {
        var vm = this;
        if (timer) {
          clearTimeout(timer);
        }
        var tree = this.$refs.treeUnit;
        if (this.$refs.treeUnit) {
          var node = tree.getNode(id.toString());
          if (node) {
            tree.select(node);
          }
        } else {
          timer = setTimeout(function () {
            vm.selectUnit(id);
          }, 500);
        }
      },
      uncheck: function (val) {
        if (val == this.selectedTraversalOption) {
          this.selectedTraversalOption = null;
        }
        this.previouslySelected = this.selectedTraversalOption;
      },
      resetTree() {
        this.unitId = this.multiple ? [] : null;
        var vm = this;
        this.options = this.$store.getters.defaultUnitTreeOptions(this.syncSourceType).map(x => {
          return {
            id: x.id,
            name: x.name,
            children: [],
            code: x.code,
            nationalBudgetCode: x.nationalBudgetCode,
            hasChildren: x.hasChildren,
            isActive: x.isActive,
            isDefaultExpanded: x.isDefaultExpanded,
            label: x.label,
            parentId: x.parentId
          };
        });
        setTimeout(function () {
          vm.$refs.treeUnit.initialize();
        }, 500);
        return true;
      },
      onSelected(node, instanceId) {
        this.selectedLabel = `${node.code}(${node.nationalBudgetCode}) - ${node.label}`;
        this.$emit('select', node, instanceId);
      },
      onDeselected(node, instanceId) {
        this.selectedLabel = null;
        this.$emit('deselect', node, instanceId);
      }
    },
    watch: {
      unitId() {
        this.$emit('input', this.unitId);
        this.$emit('change', this.$refs.treeUnit.selectedNodes);

        if (this.cached && !this.multiple) {
          if (!this.unitId) {
            window.localStorage.setItem(`tsc:${this.$store.state.identity.username}-${this.syncSourceType}-unitTreeId`, '');
            this.$store.commit("setCurrentUnit", '');
          } else {
            window.localStorage.setItem(`tsc:${this.$store.state.identity.username}-${this.syncSourceType}-unitTreeId`, this.unitId);
            this.$store.commit("setCurrentUnit", this.$refs.treeUnit.selectedNodes[0].label);
          }
        }
      },
      //value(id) {
      //    if (id != this.unitId) {
      //        this.selectUnit(id);
      //    }
      //},
      selectedTraversalOption(value) {
        this.$emit('update:traversalOption', value);

        if (this.cached && this.allowTraversal) {
          if (!value) {
            window.localStorage.setItem(`tsc:${this.$store.state.identity.username}-unitTreeTraversalOption`, '');
          } else {
            window.localStorage.setItem(`tsc:${this.$store.state.identity.username}-unitTreeTraversalOption`, value);
          }
        }
      },
      syncSourceType() {
        this.$refs.treeUnit.clear();
        this.resetTree();
      },
      isLoaded(value) {
        this.$emit('update:isLoaded', value);
      }
    }
  }
</script>
<style scoped>
  .custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
    background-color: #fff !important;
  }

  .custom-checkbox {
    margin-top: 0px !important;
  }

  .inactive-node {
    font-style: italic;
    /*text-decoration: line-through;*/
    opacity: 0.5;
    color: red;
  }
</style>

